import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../../components/SeoHead";
import MainBanner from "../../../../components/MainBanner";
import AllConsultants from "../../../../components/AllConsultants";
import MultiColumnCTAWithDivider from "../../../../components/MultiColumnCTAWithDivider";
import NewColumnWithForm from "components/NewColumnWithForm";

export default function MeetTheTeam({
  global,
  all_consultants,
  all_talent_acquisition_team,
}) {
  return (
    <>
      <SeoHead
        page_name={`Meet the SRG Team | Life Sciences Specialists in the US`}
        description={`Meet the dedicated specialists behind SRG, bringing deep experience and industry knowledge to support clients and candidates.`}
        canonical_link={`about-us/meet-the-team`}
        en_gb={false}
        en_us={true}
      />
      <MainBanner
        global={global}
        pathPrefix={`us.meet_the_team_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Meet the Team</h1>
          </>
        }
        imageURL1={`/site-assets/images/main-banner.jpg`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
      />
      <AllConsultants
        global={global}
        pathPrefix={`us.meet_the_team_page.all_consultants`}
        customClass={`py-5 grayGradientBg`}
        content={
          <>
            <h2>Our Team</h2>
          </>
        }
        content_2={
          <>
            <h2>Talent Acquisition Team</h2>
          </>
        }
        post={all_consultants}
        post2={all_talent_acquisition_team}
      />
      {/* <MultiColumnCTAWithDivider
                global={global}
                pathPrefix={`us.meet_the_team_page.multi_column_cta`}
                customClass={`pt-5 pb-md-4 pb-5`}
                left_content={
                    <>
                        <h2>Get in Touch</h2>
                    </>
                }
                right_content={
                    <>
                        <h2>Work for us</h2>
                    </>
                }
                buttonLink2={`/`}
                buttonLink1={`/`}
                buttonTitle1={`Contact us`}
                buttonTitle2={`Join us now`}
            /> */}
      <NewColumnWithForm
        global={global}
        pathPrefix={`us.insights_page.new_column_with_form`}
        customClass={`pb-5`}
        heading={`How can we help you?`}
        formId={`e1da7ff6-feb2-4696-93be-b43ec16b6009`}
        description={
          <>
            <p>
              Contact us if you are interested in finding out more about how we
              can help you.
            </p>
          </>
        }
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const consultants = (await Collection("consultants"))
    .filter(function (post) {
      return post.tag?.en !== "Talent Acquisition Team";
    })
    .filter(function (post) {
      return post.country?.en == "US";
    });

  const talent_acquisition_team = (await Collection("consultants"))
    .filter(function (post) {
      return post.tag?.en.includes(`Talent Acquisition Team`);
    })
    .filter(function (post) {
      return post.country?.en == "US";
    });
  const all_talent_acquisition_team = talent_acquisition_team
    .orderBy("_order")
    .getItems();
  const all_consultants = consultants.orderBy("_order").getItems();

  return {
    props: {
      global,
      all_consultants,
      all_talent_acquisition_team,
    },
  };
}
